module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.noBackground ? '' : 'bg-bordered'
  }, [(_vm.st) ? _c('el-row', {
    attrs: {
      "justify": "center",
      "gutter": 12
    }
  }, [(_vm.showRequests && _vm.st.rta) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Acquire",
      "icon": "fa fa-street-view",
      "value": _vm.st.rta,
      "color": "goldenrod",
      "url": '/requests/acquire' + (_vm.orgId ? '/' + _vm.orgId : ''),
      "no-plural": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRequests && _vm.st.rts) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Share",
      "icon": "fa fa-share-alt",
      "value": _vm.st.rts,
      "color": "limegreen",
      "url": '/requests/share' + (_vm.orgId ? '/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRequests && _vm.st.rtu) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Upgrade",
      "icon": "fa fa-tools",
      "value": _vm.st.rtu,
      "color": "dodgerblue",
      "url": '/requests/upgrade' + (_vm.orgId ? '/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRequests && _vm.st.rtb) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Backhaul",
      "icon": "fa fa-wifi",
      "value": _vm.st.rtb,
      "color": "grey",
      "url": '/requests/backhaul' + (_vm.orgId ? '/' + _vm.orgId : ''),
      "no-plural": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRequests && _vm.st.permits) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": _vm.permitLabel,
      "no-plural": "",
      "value": _vm.st.permits,
      "icon": "fa fa-file-alt",
      "color": "slategrey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.st.tickets) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Ticket",
      "icon": "fa fa-headset",
      "value": _vm.st.tickets,
      "color": "orange",
      "url": '/tickets' + (_vm.orgId ? '/null/null/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.isTowerCo() && (_vm.st.ticketCritical)) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Critical",
      "no-plural": "",
      "icon": "fa fa-asterisk",
      "value": _vm.st.ticketCritical,
      "color": "indianred",
      "url": '/tickets/null/critical' + (_vm.orgId ? '/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.isTowerCo() && (_vm.st.ticketUrgent)) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Urgent",
      "no-plural": "",
      "icon": "fa fa-chevron-up",
      "value": _vm.st.ticketUrgent,
      "color": "indianred",
      "url": '/tickets/null/urgent' + (_vm.orgId ? '/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.st.ticketPending) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Pending",
      "no-plural": "",
      "value": _vm.st.ticketPending,
      "icon": "fa fa-clock",
      "color": "lightgrey",
      "url": '/tickets/pending' + (_vm.orgId ? '/null/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.st.ticketOpen) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Open",
      "no-plural": "",
      "value": _vm.st.ticketOpen,
      "icon": "fa fa-folder-open",
      "color": "slategrey",
      "url": '/tickets/open' + (_vm.orgId ? '/null/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.st.ticketActive) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Active",
      "no-plural": "",
      "value": _vm.st.ticketActive,
      "icon": "fa fa-tasks",
      "color": "navy",
      "url": '/tickets/active' + (_vm.orgId ? '/null/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.st.ticketOverdue) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Overdue",
      "no-plural": "",
      "value": _vm.st.ticketOverdue,
      "icon": "fa fa-hourglass-end",
      "color": "orange",
      "url": '/tickets/overdue' + (_vm.orgId ? '/null/' + _vm.orgId : '')
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showOnlyRequests && _vm.st.ticketClosed) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Closed",
      "no-plural": "",
      "value": _vm.st.ticketClosed,
      "icon": "fa fa-folder",
      "url": '/tickets/completed-closed' + (_vm.orgId ? '/null/' + _vm.orgId : '')
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2694dcc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/OpStats.vue
// module id = 1381
// module chunks = 0